var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcClose = function SvgIcClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78 2.72a.75.75 0 0 0-1.06 1.06L6.94 8.002 2.72 12.224a.75.75 0 1 0 1.06 1.06l4.222-4.221 4.222 4.222a.75.75 0 0 0 1.06-1.061L9.064 8.002l4.222-4.222a.75.75 0 1 0-1.061-1.06L8.002 6.94 3.78 2.72Z"
  })));
};
export default SvgIcClose;